import {
  CustomContainer,
  MainTitle,
  Wrapper,
} from "../styles/CommonQuestionsStyles";

import { CommonQuestionAccordion } from "./CommonQuestionAccordion";
import { ProductRequirement } from "./ProductRequirement";
import { useCommonQuestions } from "./useCommonQuestions";

export const CommonQuestions = () => {
  const { questions, expanded, handleChange } = useCommonQuestions();

  return (
    <Wrapper
      id="common-questions"
      data-testid="common-questions"
      aria-labelledby="duvidas"
    >
      <CustomContainer>
        <MainTitle id="duvidas" variant="h2">
          Tire suas dúvidas
        </MainTitle>

        {questions.map((item) => (
          <CommonQuestionAccordion
            key={`panel${item.id}`}
            item={item}
            expanded={expanded}
            handleChange={handleChange}
          />
        ))}

        <ProductRequirement
          expanded={expanded}
          handleChange={handleChange}
        />
      </CustomContainer>
    </Wrapper>
  );
};